export default "__VITE_PUBLIC_ASSET__331a48d7__"